module.exports = __webpack_public_path__ + "assets/img/1086cfce5ea6d36ff5edf76b33c08b99.svg";